<template>
  <section>
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <!-- <el-form-item label="类型:">
        <el-select v-model="dataForm.IsStop" placeholder="类型">
          <el-option label="停机" :value="true">
          </el-option>
          <el-option label="复机" :value="false">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="号码:" prop="Tel">
        <el-input type="textarea" v-model="dataForm.Tel" placeholder="请输入号码" clearable rows="1"></el-input>
      </el-form-item>
      <el-form-item label="时间:">
        <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" @change="changeDate">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleGetDataList" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="dataList" v-loading="dataListLoading" ref="table" class="custom-tbl" style="width: 100%">
      <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
      <!-- <el-table-column type="index" width="80"> </el-table-column> -->
      <el-table-column align="center" prop="Tel" label="手机号" wdith="400"></el-table-column>
      <el-table-column align="center" prop="Operator" label="操作人" wdith="400"></el-table-column>
      <el-table-column align="center" prop="OperationType" label="停机类型" v-if="dataForm.IsStop">
        <!-- <template slot-scope="scope">
          {{
      scope.row.StopType == 0 ? "手工停机" :
        scope.row.StopType == 1 ? "黑名单停机" :
          scope.row.StopType == 2 ? "欠费停机" :
            scope.row.StopType == 3 ? "未续费停机" :
              scope.row.StopType == 4 ? "质检停机" :
                scope.row.StopType == 5 ? "投诉停机" :
                  ""
    }}
        </template> -->
      </el-table-column>
      <el-table-column align="center" prop="IsSuccess" label="是否成功" width="250">
        <template scope="scope">
          {{
        scope.row.IsSuccess == null
          ? "未执行"
          : scope.row.IsSuccess == false
            ? "失败"
            : scope.row.IsSuccess == true
              ? "成功"
              : ""
      }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="CreateTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="TaskTime" label="执行时间"></el-table-column>
      <!-- <el-table-column prop="Status" label="状态" width="80"  align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Status ? "启用" : "禁用" }}</el-tag
          >
        </template>
    </el-table-column> -->
      <!-- <el-table-column label="操作" width="250" fixed="right">
        <template scope="scope">
          <el-button size="small" type="text" @click="downloadExcelFile(scope.row.FilePath)"
            >点击下载</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="Remark" label="备注"></el-table-column>
    </el-table>
    <el-pagination @size-change="pageSizeChangeHandle1" @current-change="pageCurrentChangeHandle1" :current-page="page"
      :page-sizes="pageSizes" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"
      style="float: right; margin-top: 15px">
    </el-pagination>
    <ImportStopNumber ref="importStopNumber" @ok="getDataList"></ImportStopNumber>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import ImportStopNumber from "./importStopNumber.vue";
import { read, utils } from "xlsx";
export default {
  components: { ImportStopNumber },
  mixins: [viewModule],
  props: {
    IsStop: {
      type: Boolean
    },
  },
  data() {
    return {
      time: "",
      dataForm: {
        Tel: "",
        StartT: "",
        EndT: "",
        IsStop: this.IsStop,
      },
      mixinViewModuleOptions: {
        requestMethod: "post",
        getDataListIsPage: true,
        getDataListURL: "/api/FilterCaller/PostAllStopRecordList",
        deleteURL: "",
      },
    }
  },
  methods: {
    pageSizeChangeHandle1(val) {
      this.page = 1
      this.limit = val
      this.handleGetDataList()
    },
    pageCurrentChangeHandle1(val) {
      this.page = val
      this.handleGetDataList()
    },
    handleGetDataList() {
      this.page = 1
      if (this.dataForm.Tel !== '') { 
        const oldtel = JSON.parse(JSON.stringify(this.dataForm.Tel));
        if (typeof this.dataForm.Tel === 'string') {
          this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
        }
        console.log(this.page)
        this.query();
        this.dataForm.Tel = oldtel;
      }
      else
      this.query()
    },
    ExcelAdd() {
      this.$refs.importStopNumber.init();
    },
    downloadExcelFile(path) {
      window.open(path);
    },
    changeDate(e) {
      if (e) {
        // 调整时区偏移
        const start = new Date(e[0]);
        const end = new Date(e[1]);
        const offset = start.getTimezoneOffset() * 60000; // 毫秒
        this.dataForm.StartT = new Date(start.getTime() - offset).toISOString();
        this.dataForm.EndT = new Date(end.getTime() - offset).toISOString();
      } else {
        this.dataForm.StartT = "";
        this.dataForm.EndT = "";
      }
    },
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>